console.log(
"MONOGRAM ENGINE LOADED"
);

function applyMonogram(type){

const layers =
document.querySelectorAll(
".embroidery-text-layer"
);

layers.forEach(layer=>{

layer.classList.remove(
"monogram-traditional",
"monogram-interlocking",
"monogram-stacked",
"monogram-split"
);

if(type==="none") return;

layer.classList.add(
"monogram-" + type
);

});

}

document.addEventListener(
"DOMContentLoaded",
()=>{

document
.querySelectorAll(
"#monogram-grid .option-card"
)
.forEach(card=>{

card.addEventListener(
"click",
()=>{

const type =
card.dataset.monogram;

console.log(
"MONOGRAM CLICKED",
type
);

document
.querySelectorAll(
"#monogram-grid .option-card"
)
.forEach(c=>
c.classList.remove(
"active"
)
);

card.classList.add(
"active"
);

document.getElementById(
"monogramStyle"
).value = type;

applyMonogram(type);

rebuildMonogramText(type);

}
);

});

});
function rebuildMonogramText(type){

const activeLayer =
document.querySelector(
".embroidery-text-layer.active-layer"
);

if(!activeLayer) return;

const textContainer =
activeLayer.querySelector(
".text-content"
);

if(!textContainer) return;

const text =
textContainer.dataset.originalText ||
textContainer.textContent;

textContainer.dataset.originalText =
text;

if(type==="stacked"){

textContainer.innerHTML =
text.split("")
.join("<br>");

}

else{

textContainer.innerHTML = text;

}

}
